import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LocalService} from '../../../_services/local.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {IonSearchbar} from '@ionic/angular';

@Component({
  selector: 'app-search-component',
  templateUrl: './search-component.component.html',
  styleUrls: ['./search-component.component.scss'],
  standalone: false
})
export class SearchComponentComponent implements OnInit, OnDestroy {
  @Input() placeholder = 'Ricerca';
  /**
   * Canale su cui pubblicare la ricerca. Senza input è `LocalService.searchText`, il canale globale che
   * la schermata principale dell'avanzamento manuale interpreta come barcode d'ordine (9, 13 o 17 cifre):
   * chi cerca altro nella stessa pila di navigazione (es. il selettore risorse) deve passarne uno proprio,
   * altrimenti lo stesso invio filtra l'elenco e lancia anche la ricerca ordine.
   * Va impostato una volta sola: è letto in `ngOnInit`.
   */
  @Input() searchChannel?: BehaviorSubject<string>;
  @ViewChild('mySearchBar', {static: false}) searchbar!: IonSearchbar;
  showSearch = true;
  searchText: string;
  timeout: ReturnType<typeof setTimeout> | null = null;
  subscription: Subscription;

  constructor(
    private localService: LocalService) { }

  private get channel(): BehaviorSubject<string> {
    return this.searchChannel ?? this.localService.searchText;
  }

  ngOnInit() {
    this.subscription = this.channel
      .subscribe((value: string) => {
        this.searchText = value;
        if (!value) {
          this.cancelPendingSearch();
        }
      });
  }

  ngOnDestroy() {
    this.cancelPendingSearch();
    this.subscription?.unsubscribe();
  }

  search = () => {
    this.cancelPendingSearch();
    this.timeout = setTimeout(() => {
      this.timeout = null;
      this.channel.next((this.searchText ?? '').trim());
    }, 500);
  };

  cancelSearch = () => {
    this.cancelPendingSearch();
    this.searchText = '';
    this.channel.next(this.searchText);
  };

  closeSearch = () => {
    this.cancelPendingSearch();
    this.searchText = '';
    this.showSearch = false;
    this.channel.next(this.searchText);
  };

  private cancelPendingSearch() {
    if (this.timeout !== null) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}
